import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import '@componentes/_util/color.override.css';
import '@componentes/_util/style.override.css';
import '@componentes/_util/icons/mv-basico/css/mv-basico.old.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'vivace-fluent-motion/es/assets/styles/_util/icons/mv-basico/css/mv-basico.old.css';
import 'vivace-fluent-motion/es/assets/styles/_util/icons/mv-basico/css/mv-basico.css';
import 'rc-switch/assets/index.css';
import store from './configureStore.util';
import { Init } from './init';

ReactDOM.render(
  <Provider store={store}>
   <Init />
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js